<template>
  <div class="">
    <table border="1">
      <tr>
        <th :colspan="3">组长日常职责</th>
      </tr>

      <tr>
        <!-- <th>序号</th>
        <th>职责范围</th>
        <th>备注</th> -->
        <template v-for="(item, index) in tableList.header" :key="index">
          <td>{{ item }}</td>
        </template>
      </tr>

      <template v-for="(item, index) in tableList.body" :key="index">
        <tr>
          <td class="text-center">{{ index + 1 }}</td>
          <td>{{ item.text }}</td>
          <td></td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import { computed, defineComponent, reactive } from "vue";

export default defineComponent({
  props: {
    responsibilityType: String,
  },
  setup(props) {
    const responsibilityList = reactive({
      produce: {
        header: ["序号", "职责范围", "备注"],
        body: [
          {
            text: "生产任务与人员调配",
          },
          {
            text: "作业指导书的执行",
          },
          {
            text: "记录表的执行",
          },
          {
            text: "工位检查：仪器设备，工装工具，5s，在岗，违规",
          },
          {
            text: "工艺变更的掌握和首样确认",
          },
          {
            text: "组员培训",
          },
          {
            text: "组员的首样确认",
          },
          {
            text: "每天抽查组员的质量和产能",
          },
          {
            text: "组员的批评教育",
          },
          {
            text: "异常问题处理和统计（包括停产，截流整改）",
          },
          {
            text: "问题反馈与交流：特别是一次操作合格率",
          },
          {
            text: "组间沟通：生产任务沟通，异常问题沟通",
          },
          {
            text: "组内沟通：生产任务沟通，异常问题沟通，其他信息传达",
          },
        ],
      },
      qualityInspection: {
        header: ["序号", "职责范围", "备注"],
        body: [
          {
            text: "生产任务与人员调配",
          },
          {
            text: "作业指导书的执行",
          },
          {
            text: "记录表的执行",
          },
          {
            text: "工位检查：仪器设备，工装工具，5s，在岗，违规",
          },
          {
            text: "工艺变更的掌握和首样确认",
          },
          {
            text: "组员培训",
          },
          {
            text: "组员的首样确认",
          },
          {
            text: "每天抽查组员的质量和产能",
          },
          {
            text: "组员的批评教育",
          },
          {
            text: "异常问题处理和统计（包括停产，截流整改）",
          },
          {
            text: "问题反馈与交流：特别是一次操作合格率",
          },
          {
            text: "组间沟通：生产任务沟通，异常问题沟通",
          },
          {
            text: "组内沟通：生产任务沟通，异常问题沟通，其他信息传达",
          },
        ],
      },
    });

    const tableList = computed(() => {
      if (
        props.responsibilityType === "produce" ||
        props.responsibilityType === "qualityInspection"
      ) {
        return responsibilityList[props.responsibilityType];
      }
      return [];
    });

    return {
      props,
      tableList,
      responsibilityList,
    };
  },
});
</script>

<style lang="less" scoped>
table {
  font-size: 16px;
}
table > tr > td, th {
    padding: 5px 10px;
    // text-align: center;
}
th {
    text-align: center;
}
.text-center {
  text-align: center;
}
</style>
